import React, { useState, useCallback, memo } from "react";
import { Button, Icon, Text } from "@chakra-ui/react";
import { FaRegCircleDot, FaRegCircle, FaCircleCheck } from "react-icons/fa6";
import { FaClock, FaCircleHalfStroke, FaCircleXmark } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import {
  buttonGreen,
  color1,
  color2,
  color3,
  color4,
  color5,
  color6,
  color8,
  newBorder,
} from "../../utils/colors";
import {
  buttonBlue,
  buttonBlueDark,
  buttonYellow,
  buttonYellowDark,
  buttonGreenDark,
  buttonRed,
  buttonRedDark,
  buttonAltGrey,
  buttonAltGreen,
  buttonAltYellow,
  buttonAltSuccess,
  textPrimary,
  white,
  buttonGreenVividDark,
  textSecondary,
  text,
} from "../../utils/colors";
import { shade } from "polished";

const StatusButtonNewLiteTp = ({ currentStatus, p, w }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  const options = [
    {
      value: "draft",
      label: t("status.draft"),
      icon: FaRegCircle,
      bg: buttonAltGrey,
      bgDark: textSecondary,
      color: textSecondary,
      borderColor: newBorder,
      bgHover: "#ddd",
    },
    {
      value: "approved",
      label: t("status.treatmentPlanApproved"),
      icon: FaCircleCheck,
      bg: color3,
      bgDark: buttonGreenDark,
      color: white,
      borderColor: buttonGreen,
      bgHover: "#9ebfc2",
    },

    {
      value: "consulting",
      label: t("status.treatmentPlanConsulting"),
      icon: FaClock,
      bg: color1,
      bgDark: buttonBlueDark,
      color: white,
      borderColor: newBorder,
      bgHover: "#ddd",
    },
    {
      value: "planning",
      label: t("status.treatmentPlanPlanning"),
      icon: FaClock,
      bg: color2,
      bgDark: buttonYellowDark,
      color: white,
      borderColor: buttonYellow,
      bgHover: "#9ebfc2",
    },
    {
      value: "completed",
      label: t("status.treatmentPlanCompleted"),
      icon: FaCircleCheck,
      bg: color5,
      bgDark: buttonGreenDark,
      color: textPrimary,
      borderColor: buttonGreen,
      bgHover: "#9ebfc2",
    },
    {
      value: "cancelled",
      label: t("status.treatmentPlanCancelled"),
      icon: FaCircleXmark,
      bg: color6,
      bgDark: buttonRedDark,
      color: white,
      borderColor: buttonRed,
      bgHover: "#dda3a3",
    },
    {
      value: "ongoing",
      label: t("status.ongoing"),
      icon: FaCircleHalfStroke,
      bg: color4,
      bgDark: buttonYellowDark,
      color: white,
      borderColor: buttonAltYellow,
      bgHover: "#9ebfc2",
    },
  ];

  const currentStatusOption = options.find(
    (option) => option.value === currentStatus
  );

  return (
    <Button
      as={Button}
      onClick={handleClick}
      size="md"
      // h={isSmall ? "2.25rem" : "2.5rem"}
      bg={currentStatusOption ? currentStatusOption.bg : white}
      color={currentStatusOption ? currentStatusOption.color : textSecondary}
      display="flex"
      alignItems="center"
      justifyContent="center"
      _hover={{
        bg: shade(0.3, currentStatusOption ? currentStatusOption.bg : white),
        color: white,
      }}
      borderRadius="0.75rem"
      _active={{
        bg: currentStatusOption ? currentStatusOption.bg : white,
        color: currentStatusOption ? currentStatusOption.color : textSecondary,
      }}
      p={p ? p : " 0 5rem"}
      w={w ? w : "initial"}
      // isDisabled={isDisabled}
    >
      {currentStatusOption && (
        <>
          <Icon
            as={currentStatusOption.icon}
            mr={1}
            fontSize="0.75rem"
            opacity="1"
            position="relative"
            // top="-1px"
          />

          <Text fontSize="0.875rem" fontWeight="500" lineHeight="1">
            {currentStatusOption?.label}
          </Text>
        </>
      )}
    </Button>
  );
};

export default memo(StatusButtonNewLiteTp);
